<template>
    <div class="container page">
        <van-nav-bar :title="$t('liping')" class="nav-bar">
            <template #left>
                <van-icon name="arrow-left" color="#d7d7d7" @click="back()" />
            </template>
        </van-nav-bar>
        <div class="main-box">


            <van-cell-group>
                <van-field v-model="money" :label="$t('liping')" type="number" :placeholder="$t('lipingjine')" />

                <van-field name="uploader" :label="$t('lipingimg')">
                    <template #input>
                        <van-uploader :after-read="afterRead" v-model="uploader" max-count="1">

                        </van-uploader>
                    </template>
                </van-field>


                <!-- <van-field v-model="mobile" :label="$t('setting.mobile')" type="digit" :placeholder="$t('setting.mobile_place')" /> -->
            </van-cell-group>


        </div>
        <van-button class="bindCard" :disabled="isDisabled" type="default" @click="bindCard()">{{
            $t("reservation.submit")
            }}</van-button>
    </div>
</template>

<script>
import { baseURL } from '@/http/index.js'
export default {
    data() {
        return {
            getImageHttp: baseURL + '/images/head/',
            isDisabled: false,
            money: '',
            isActive: '',
            uploader: []
        };
    },
    methods: {

        back() {
      return window.history.back();
    },
        bindCard() {
            if (this.money == 0) {
                this.$toast(this.$t("lipingmoney"));
                return false;
            }

            if (!this.isActive) {
                this.$toast(this.$t("lipingimgpls"));
                return true;
            }
            console.log(this.uploader)
            this.isDisabled = true

            // if(this.mobile===""){
            //   this.$toast(this.$t("setting.mobile_place"));
            //   return false;
            // }

            this.$http({
                method: 'post',
                data: {
                    money: this.money,
                    card_img: this.isActive
                },
                url: 'membercard'
            }).then(res => {
                if (res.code === 200) {
                    this.$toast(res.msg);
                    this.back()
                } else if (res.code === 401) {
                    this.$toast(res.msg);
                }
                this.isDisabled = false
            })
        },

        afterRead(file) {
            console.log(222, file)
            // 此时可以自行将文件上传至服务器
            this.$http({
                method: 'file',
                data: { file: file },
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                url: 'sys_uploadimg'
            }).then(res => {
                if (res.code === 200) {
                    this.isActive = baseURL + res.data
                    console.log(this.isActive)
                } else if (res.code === 401) {
                    this.$toast(res.msg);
                }
            })
        },
    },
    mounted() {

    }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.copy_btn {
    border-radius: 50px;
    color: #ffffff;
    padding: 30px 20px;
    font-size: 30px;
    font-weight: bolder;
    border: none;
    background: linear-gradient(90deg, #7030a0, #7030a0);
}

.van-cell {
    font-size: 28px;
    line-height: 80px;
}

/deep/ .van-field__label {
    width: 32%;
}


.bankbox {
    padding: 15px;
    color: #000;
    background-color: #ffffff;
}

.bankbox .title {
    padding: 8px 10px 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 28px;
}

.main-box {
    background: #fff;

}

.main-box .label {
    padding: 20px;
    font-size: 35px;
    color: #797878;
}

::v-deep .van-picker__toolbar {
    height: 80px;
}

::v-deep .van-picker__cancel,
.van-picker__confirm {
    padding: 0 20px;
    font-size: 20px;
}

::v-deep .van-picker-column {
    font-size: 40px;
}

.main-box p {
    padding: 0 20px;
    font-size: 30px;
    color: #ee0a24;
}

.bindCard {
    margin: 20px 30px 0;
    height: 80px;
    line-height: 1.22667rem;
    border-radius: 50px;
    color: #ffffff;
    font-size: 30px;
    font-weight: bolder;
    border: none;
    background: linear-gradient(90deg, #7030a0, #7030a0);
}

/deep/.van-picker__confirm,
/deep/.van-picker__cancel {
    font-size: 36px;
}
</style>